import { CircleNotch } from "@phosphor-icons/react";
import { Button, Text } from "@radix-ui/themes";

interface StillProcessingIndicatorProps {
  fileName: string;
  retrying?: boolean;
  onRetry?: () => void;
}

/** Presentational shell for file-preview "still processing" state (no polling). */
export function StillProcessingIndicator({
  fileName,
  retrying = false,
  onRetry,
}: StillProcessingIndicatorProps) {
  return (
    <div
      className="flex items-center gap-3 rounded-lg border border-puntt-neutral-gray-6 bg-puntt-neutral-gray-2 p-4"
      data-testid="file-preview-still-processing"
      aria-label="File is still processing"
    >
      <CircleNotch
        size={20}
        className="shrink-0 animate-spin text-puntt-neutral-gray-9"
        aria-hidden="true"
      />
      <div className="flex-1">
        <Text size="2" weight="medium" className="text-puntt-neutral-gray-12">
          {fileName}
        </Text>
        <Text as="p" size="1" className="text-puntt-neutral-gray-9">
          Still processing your file…
        </Text>
      </div>
      <Button
        data-testid="file-preview-still-processing-retry"
        size="1"
        variant="soft"
        aria-label="Retry loading file"
        disabled={retrying}
        onClick={onRetry}
        className="cursor-pointer"
      >
        Retry
      </Button>
    </div>
  );
}
